import { render, staticRenderFns } from "./school-assignment-report.vue?vue&type=template&id=74b9621c&scoped=true"
import script from "./school-assignment-report.vue?vue&type=script&lang=js"
export * from "./school-assignment-report.vue?vue&type=script&lang=js"
import style0 from "./school-assignment-report.vue?vue&type=style&index=0&id=74b9621c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b9621c",
  null
  
)

export default component.exports